'use client';

import CarSwiper from './CarSwiper/CarSwiper';

export default function NewHero({ hero, buttonConfig }) {
  return (
    <div className="container">
      <CarSwiper data={hero} buttonConfig={buttonConfig} />
    </div>
  );
}
